<template>
    <ClientSummary
        v-if="!isError.hasError && !isLoading"
        :client="infoClient"
        :ui="ui"
        :balance="infoClient.total"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError && !isLoading">
        <header>
            <v-card-title>Gestiones</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <div class="content_accion">
            <div>
                <v-text-field
                    v-model="searchGestiones"
                    label="Búsqueda"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="outlined"
                    hide-details
                    class="filter"
                    :disabled="isLoading"
                ></v-text-field>
            </div>
            <div>
                <v-btn
                    icon="mdi-reload"
                    size="small"
                    variant="outlined"
                    color="indigo-darken-3"
                    class="mr-2"
                    @click="getManagementList()"
                    :disabled="isLoading"
                ></v-btn>
            </div>
        </div>
        <v-data-table
            :headers="dataSourceGestiones.headers"
            :items="dataSourceGestiones.data"
            :search="searchGestiones"
            :loading="isLoading"
            no-data-text="Sin datos para mostrar"
            loading-text="Cargando información... Espere un momento"
        ></v-data-table>
    </div>
    <div v-if="isError.hasError && !isLoading" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>
    <div v-if="isLoading" class="content_load h-100" >
        <v-progress-circular
            :size="100"
            :width="7"
            color="indigo-darken-3"
            indeterminate
        ></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando la Información de las Gestiones</div>
    </div>
    <SnackbarComponent :value="snackbarData"/>
</template>
<script>
import { DespachoCatalogService } from '@/services/DespachoCatalogService';
import ClientSummary from '@/components/managements/ClientSummary.vue'
import { EncryptService } from '@/services/EncryptService';
import { ManagementsService } from '@/services/ManagementsService';
import SnackbarComponent from '@/components/Snackbar'
import { ResourcesService } from '@/services/ResourcesService';
import { useUiStore } from '@/stores/ui'
export default {
    name: "ManagementView",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },    
    data() {
        return {
            searchGestiones: '',
            isLoading: false,
            isError: {
                hasError: false,
                msg: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            dataSourceGestiones: {
                data: [],
                headers: [
                    {
                        align: "start",
                        key: "folioGen",
                        title: "Folio",
                    },
                    {
                        key: "comentario",
                        title: "Comentarios",
                    },
                    {
                        key: "codigo_accion_descripcion",
                        title: "Código Acción Descripción",
                    },
                    {
                        key: "codigo_resultado_descripcion",
                        title: "Código Resultado Descripción",
                    },
                ],
            },
            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            typeClassConvenio: 'gray',
        }
    },
    computed:{
        ui() {
            const store = useUiStore()
            return store.ui;
        },
    },
    async mounted() {
        try {
            const { settings } = await DespachoCatalogService.management();
            this.dataSourceGestiones.headers = this.dataSourceGestiones.headers.map(h => ({ ...h,
                title: h.key === 'codigo_accion_descripcion' ? settings.action_label : h.key === 'codigo_resultado_descripcion' ? settings.result_label : h.title }));
            if (settings.dictamen_mode !== 'disabled') this.dataSourceGestiones.headers.push({ key: 'dictamen_snapshot', title: settings.dictamen_label });
        } catch (e) { this.snackbarData = { openSnackbar: true, description: 'No se pudieron cargar las etiquetas de gestión.' }; }
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created() {
        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        const PARAMS = await EncryptService.decrypt(DATA_PARAMS)
        if (PARAMS === null || PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.`
            return;
        }
        const ARR_PARAMS = JSON.parse(PARAMS);
        this.idClient = ARR_PARAMS.id

        this.isLoading = true
        await this.getClientInformation()
        await this.getManagementList()
        this.isLoading = false
    },
    methods: {
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.infoClient = responseData.response
                        this.infoClient.total = ResourcesService.moneyFormat(this.infoClient.total)
                        switch (this.infoClient.estado) {
                            case 'Convenio Activo':
                            case 'Convenio Completado':
                            case 'Pago Intención Activo':
                            case 'Pago Intención Completado':
                                this.typeClassConvenio = 'green';
                                break;
                            case 'Sin convenio':
                                this.typeClassConvenio = 'gray';
                                break;
                            case 'Convenio Cancelado':
                            case 'Pago Intención Cancelado':
                                this.typeClassConvenio = 'red';
                                break;
                            default:
                                this.typeClassConvenio = 'gray';
                        }
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getManagementList: async function () {
            this.isLoading = true
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getManagementList(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {            
                        this.dataSourceGestiones.data = responseData.response
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
    }
}
</script>
<style scoped>
    .title_container {
        width: 100%;
        display: flex; 
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
    }
    .title_section {
        width: 25%; 
        display: flex;  
        justify-content: center;
        font-size: 10pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }
    .container_submenu {
        height: calc(100% - 50px);
        overflow: auto;
        margin-bottom: 30px;
    }
</style>